const queryKeys = {
  STORE: {
    ALL: ['store', 'all'],
    DETAILS: ['store', 'details'],
    RECENT: ['store', 'recent'],
    RECOMMENDED: ['store', 'recommended'],
    REVIEWS: ['store', 'details', 'reviews'],
    ITEM_REVIEWS: ['store', 'item', 'reviews'],
    RATINGS: ['store', 'item', 'ratings'],
  },
  MENU: {
    ALL: ['menu', 'all'],
  },
  CORE_CONFIG: ['core_config'],
  ADDRESS: {
    ALL: ['address', 'all'],
  },
  ORDER: {
    ALL: ['order', 'all'],
    DETAILS: ['order', 'details'],
    COMPLETED: ['order', 'completed'],
  },
  SEARCH: ['search'],
  USER: {
    INFO: ['user', 'info'],
    MONEY: ['user', 'info', 'money'],
  },
  COUPON: {
    ALL: ['coupon', 'all'],
  },
  ACCOUNT: {
    ALL: ['account', 'all'],
  },
  REFUND: {
    ALL: ['refund', 'all'],
  },
  STORE_AVAILABILITY: {
    CHECK: ['store_availability', 'check'],
  },
  LOG: {
    POINTS: {
      TOTAL: ['log', 'points', 'total'],
    },
  },
};

export default queryKeys;
